import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { PersonSearchService } from "../_services/person-search.service";
import { LocalStorageService } from "../_services/local-storage.service";
import { CandidateService } from "../_services/candidate.service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from "moment";
import { TransactionService } from "../_services/transaction.service";
import { CandidateEmailComponent } from "../candidate/candidate-email/candidate-email.component";
import { Router } from "@angular/router";
import * as __ from 'lodash';
import { WebbtreeVerifiedService } from "../_services/webbtree-verified.service";
import { CampaignService } from "../_services/campaign.service";


@Component({
  selector: "app-person-search-contact-slider",
  templateUrl: "./person-search-contact-slider.component.html",
  styleUrls: ["./person-search-contact-slider.component.scss"],
})
export class PersonSearchContactSliderComponent implements OnInit {
  allContactsAvailable: boolean = false;
  fetchFromProvider: boolean = false;
  radioForm: FormGroup;
  webbtreeIntroRadioForm: FormGroup
  availableContactProviders: any;
  phones: any[] = [];
  personal_email: any[] = [];
  work_email: any[] = [];
  errorMessage: string = ''
  successMessage: string = ''
  allExistingContactDetails: any;

  isPhoneAvailable: boolean = false;
  isworkEmailAvailable: boolean = false;
  isPersonalEmailAvailable: boolean = false;

  @Input() candidateDetails;
  @Input() currentIndex;
  canShowPhone: boolean = true;
  canShowPersonal_email: boolean = true;
  canShowWork_email: boolean = true;

  uniqueEnrichedvia: any[] = []
  showAllDivData:Boolean = false;
  showSuccessfulData:Boolean = false;
  showRequestSpinner:Boolean = false;

  @ViewChild('GrabInProgress') GrabInProgress: TemplateRef<any>;
  @ViewChild('webbtreeIntroductionModalBox') webbtreeIntroductionModalBox: TemplateRef<any>;
    
  @Output() handleOutputEvent = new EventEmitter<{action : string, data: any}>();
  canShowFetchFromProvider: boolean = false;

  @ViewChild('noCreditsCE') noCreditsCE: TemplateRef<any>;
  isteamMember: boolean = false;
  selectedInputValues: String[] = []
  personalContactChecked: Boolean = false
  personalEmailChecked: Boolean = false
  allContactProviders: any[] = []
  isPreviewApiCalled: boolean = false;
  candidateNumber: any;
  isExtensioninstalled: any;
  colvillform: FormControl = new FormControl(null)
  webbtreeIntroForm: FormControl = new FormControl(null)
  showAllDivDataWebbtreeIntro: boolean;
  showSuccessfulDataWebbtreeIntro: boolean;
  showwebtreeintrospinner: Boolean
  isWebbtreeIntroductionChecked: Boolean = false;
  revealContactSpinner: boolean = false;
  webbtreeIntroductionForm: FormGroup;

  /**If reached here from add to manually button of email-campaign */
  @Input() addToContactOpen: boolean = false;
  /**show the add to contact section */
  canShowAddToContact: boolean = false;
  /** */
  addToContactButton: boolean = true;
  /**target data of email campaign */
  @Input() emailCampData: any;
  
  editManualContactInfo: any = {type:null, contactValue:null};

  enrichedfrom: string = 'person-search-listing';
  /** save fetch existing contact detail response for email campaign slider */
  contactInfoForEmailCamp: any = null

  canShowProvidersList: boolean = false;
  originalCandidateDetails: any;

  requirementmodal: string = '';
  constructor(
    private fb: FormBuilder,
    private personSearchService: PersonSearchService,
    private _localstorageservice: LocalStorageService,
    public candidateservice: CandidateService,
    private modalService: NgbModal,
    private transactionservice: TransactionService,
    public router: Router,
    public requestContract: WebbtreeVerifiedService,
    private campaignService: CampaignService
  ) {}

  ngOnInit() {
    this.originalCandidateDetails = this.candidateDetails
    this.segregateContactWithProviders();
    this.radioForm = this.fb.group({
      option: [""], // Initialize with default value if needed
    });
    this.webbtreeIntroductionForm = this.fb.group({
      requirement: [""]
    })

    
    this.isPreviewApiCalled = false;
    this.getAllcontactDetails();
    this.getPreviewApi()

    if (this.router.url) {
      if (this.router.url.includes('talentpool')) {
        this.enrichedfrom = 'talentpool';
      }
      else if (this.router.url.includes('candidate-list')) {
        this.enrichedfrom = 'all-candidates'
      }
      else if (this.router.url.includes('email-campaign')) {
        this.enrichedfrom = 'email-campaign-target-listing'
      }
    }
    this.candidateNumber = this.candidateDetails?.candidatenumber || this.candidateNumber;
    if(this.enrichedfrom !== 'person-search-listing' && this.addToContactOpen){
      this.canShowAddToContact = true;
    }
    else{
      this.canShowAddToContact = false;
    }

    this.webbtreeIntroductionForm.controls.requirement.valueChanges.subscribe((result: any) => {    
      if(result && result.length > 1000){
        this.webbtreeIntroductionForm.get('requirement').setErrors({'max-count': true})
      }else if(result && result.length <= 10){
        this.webbtreeIntroductionForm.get('requirement').setErrors({'min-count': true})
      }
    });
  }

  moment = moment;

  revealContact() {
    const contactSource = this.radioForm.getRawValue().option;

    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'block'

    if(contactSource != null && contactSource != "") {
      const data = {
        elasticid: this.candidateDetails.idinindex,
        source: this.radioForm.getRawValue().option,
        enrichedfrom: this.enrichedfrom // the max length for this column is 50 character
      };
      this.revealContactSpinner = true;
      this.personSearchService.revealContact(data).subscribe((result: any) => {
        if (result && result.status == "success" && typeof result.message == 'object') {
          this.radioForm.reset();
          result.message['usedWebbtreeIntroduction'] = this.candidateDetails['usedWebbtreeIntroduction'] == 1 ? 1 : 0
          result.message['iswebbtreeverified'] = this.candidateDetails['iswebbtreeverified'] == 1 ? 1 : 0
          this.candidateDetails = result.message;
          this.fetchcredits();
          this.getAllcontactDetails('reveal');
          this.candidateNumber = result.message.candidatenumber;
          this.sendMessagetoChrome();
          
          if(data.source == 'signalhire'){
            this.modalService.open(this.GrabInProgress, { windowClass: "myCustomModalClass", centered: true });
          }
          this.candidateDetails['highlight'] = this.originalCandidateDetails['highlight']
          const eventdata = {
            action: 'append-data',
            data: this.candidateDetails
          }
          this.handleOutputEvent.emit(eventdata);
        }else if(result && result.status == "success" && result.message == 'no-details-found'){
          this.fetchFromProvider = true;

          this.dataTransferToEmailCampaignSlider(this.contactInfoForEmailCamp,'reveal');

          if(this.allExistingContactDetails && typeof this.allExistingContactDetails == 'object' && this.allExistingContactDetails != undefined &&
             ((this.allExistingContactDetails.emails &&  this.allExistingContactDetails.emails.length) || (this.allExistingContactDetails.contactnumbers && this.allExistingContactDetails.contactnumbers.length))
          ){
            setTimeout(() => {
              this.fetchFromProvider = false;
            }, 2000);
          }
        
        }else if(result && result.status == "failure" && result.message == "not-enough-credit"){
          this.errorMessage = 'Not Enough Credit';
          setTimeout(() => {
            this.errorMessage = '';
          },5000)
    
        }
        this.revealContactSpinner = false;
      }, (_) => {
        this.revealContactSpinner = false;
      });
    }else{
      this.errorMessage = 'Please select atleast 1 data provider to proceed';
      setTimeout(() => {
        this.errorMessage = '';
      },2000)

      
    }
  }

  canShowButton(source) {
    if (
      this.candidateDetails.contactDetails &&
      this.candidateDetails.contactDetails[source]
    ) {
      const object = this.candidateDetails.contactDetails[source];
      const truValues = [];

      for (const key in object) {
        if (
          typeof object[key] === "string" &&
          object[key].toLowerCase() === "true"
        ) {
          truValues.push(key);
        } else if (object[key] == true) {
          truValues.push(key);
        }
      }

      if (truValues && truValues.length >= 1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  // checkForPhone(){
  //   this.candidateDetails.contactDetails && this.candidateDetails.contactDetails
  // }

  checkForPhone() {
    // Iterate through the contact sections
    for (const key of Object.keys(this.candidateDetails)) {
      if (key == "contactDetails") {
        for (const contactDetailsKey of Object.keys(
          this.candidateDetails["contactDetails"]
        )) {
          const section =
            this.candidateDetails["contactDetails"][contactDetailsKey];
          if (section.phone && section.phone.length > 0) {
            return false;
          }
        }
      }
    }

    // Return 'pdl' if no phone number is found
    return true;
  }

  getAllcontactDetails(fuctionCalledBy = '') {
    if (
      this.candidateDetails &&
      this.candidateDetails.hasOwnProperty("candidatenumber")
    ) {
      let data = {
        usernumber: this._localstorageservice.getItem("usernumber"),
        candidatenumber: this.candidateDetails.candidatenumber,
      };

      this.contactInfoForEmailCamp = null;
      this.candidateservice.getContactDetails(data).subscribe((result: any) => {
        if (result && result.status == "success") {
          this.allExistingContactDetails = result.data
          this.getUniqueContactProviders(result.data)
          this.fetchFromProvider = false;
          // this.getPreviewApi();
          this.availableContactProviders =  this.removeKeysFromArrayObjects(this.allContactProviders, this.uniqueEnrichedvia);
          if (result && result.data && result.data.contactnumbers.length) {
            this.isPhoneAvailable = true;
            this.phones = result.data.contactnumbers
            this.canShowPhone = true;


          }  
          if (result && result.data && result.data.emails.length) {
            const workEmails = result.data.emails.filter(
              (email) => email.contactdetailcategory == "professional"
            );
            if (workEmails && workEmails.length) {
              this.isworkEmailAvailable = true;
              this.canShowWork_email = true;
              this.work_email = workEmails;
            }


            const personal_email = result.data.emails.filter(
              (email) => email.contactdetailcategory == "personal"
            );
            if (personal_email && personal_email.length) {
              this.isPersonalEmailAvailable = true;
              this.canShowPersonal_email = true;
              this.personal_email = personal_email;
            }
          }
          if(this.phones && this.phones.length &&
            this.personal_email && this.personal_email.length &&
            this.work_email && this.work_email.length){
              this.allContactsAvailable = true
            }
            if((this.phones && this.phones.length) || (this.personal_email && this.personal_email.length) || (this.work_email && this.work_email.length)){
              this.canShowFetchFromProvider = true;
            }
            //Sent contact info to email-target-listing page
            this.contactInfoForEmailCamp = result.data;
            this.dataTransferToEmailCampaignSlider(result.data, fuctionCalledBy);
          }
      });
    }
    let eventdata = {
      action: 'append-data',
      data: this.candidateDetails
    }

    // this.handleOutputEvent.emit(eventdata)
  }

  dataTransferToEmailCampaignSlider(data, calledFrom){
    if(this.enrichedfrom === 'email-campaign-target-listing'){
      this.campaignService.setContactSliderToListingData({...data, availableContactProivders: this.availableContactProviders, calledFrom: calledFrom});
    }
  }

  segregateContactWithProviders() {
    if (this.candidateDetails && this.candidateDetails.existingContactDetails) {
      this.work_email = this.candidateDetails.existingContactDetails.filter(
        (x) => x.contactdetailcategory == "professional"
      );
      this.personal_email = this.candidateDetails.existingContactDetails.filter(
        (x) => x.contactdetailcategory == "personal"
      );
      this.phones = this.candidateDetails.existingContactDetails.filter(
        (x) => x.contactdetailcategory == "phones"
      );
      if (this.phones && this.phones.length) {
        this.canShowPhone = true;
      } else {
        this.canShowPhone = false;
      }

      if(this.phones && this.phones.length &&
        this.personal_email && this.personal_email.length &&
        this.work_email && this.work_email.length){
          this.allContactsAvailable = true
        }
      if (this.personal_email && this.personal_email.length) {
        this.canShowPersonal_email = true;
      } else {
        this.canShowPersonal_email = false;
      }

      if (this.work_email && this.work_email.length) {
        this.canShowWork_email = true;
      } else {
        this.canShowWork_email = false;
      }
    } else {
      if (
        this.candidateDetails &&
        this.candidateDetails.contactDetails &&
        this.candidateDetails.contactDetails.pdl
      ) {
        if (this.candidateDetails.contactDetails.pdl.phone == true) {
          this.canShowPhone = true;
        } else {
          this.canShowPhone = false;
        }

        if (this.candidateDetails.contactDetails.pdl.work_email == true) {
          this.canShowWork_email = true;
        } else {
          this.canShowWork_email = false;
        }

        if (this.candidateDetails.contactDetails.pdl.personal_email == true) {
          this.canShowPersonal_email = true;
        } else {
          this.canShowPersonal_email = false;
        }
      }
    }
  }

  getUniqueContactProviders(data){
    // Iterate through the data and collect unique enrichedvia values
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
          const items = data[key];
          items.forEach(item => {
              if (item.enrichedvia && !this.uniqueEnrichedvia.includes(item.enrichedvia)) {
                  this.uniqueEnrichedvia.push(item.enrichedvia);
              }
          });
      }
    }    
  }

  getPreviewApi(){
    // get all data providers and preview
    this.isPreviewApiCalled = false
    const elasticid = this.candidateDetails.idinindex;
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
    this.personSearchService
      .previewContactDetails(elasticid)
      .subscribe((result: any) => {
        if (result && result.status == "success") {
         this.allContactProviders =  __.cloneDeep(result.message)
          this.availableContactProviders =  this.removeKeysFromArrayObjects(result.message, this.uniqueEnrichedvia);
          
          this.canShowProvidersList = this.checkIfProviderisEmptyAndNoPreviewResponse(this.availableContactProviders)
          console.log(this.availableContactProviders, 'availableContactProvidersavailableContactProviders')
          this.isPreviewApiCalled = true;
        }
        // //loadn[0].style.display = 'block'
    });
    
  }

  removeKeysFromArrayObjects(obj, keysToRemove) {

    const order = ["pipl", "rocketreach", "pdl", "nymblr"];
    const sortedData = {}
    
    order.forEach(key => {
        sortedData[key] = obj[key];
    });

    for (const key in sortedData) {
      if (keysToRemove.includes(key)) {
          delete sortedData[key];
      }
    }

    
    
    return sortedData;
  }

  returnZero() {
    return 0
  }

  getWhatsappLink(phonenumber: string) {
    return `https://api.whatsapp.com/send/?phone=${phonenumber.trim().replace(/[\+\-\s]/g, '')}`;
  }

  getLastSeenText(contactDetailObj: any) {
    return (contactDetailObj?.pipl_validsince && contactDetailObj?.pipl_validsince != 'undefined' && Math.abs(moment().diff(contactDetailObj?.pipl_validsince, 'year')) < 10) ? 'Last seen ' + moment(contactDetailObj.pipl_validsince, 'YYYY-MM-DD').fromNow() : '';
  }

  copyToClipboard(content: string) {
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = content;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    this.successMessage = "Contact detail copied succesfully"
    setTimeout(() => this.successMessage = '', 3000);
  }

  markContactValidity(contactDetailObject, isValid) {
    const payload = {
      usernumber: this._localstorageservice.getItem("usernumber"),
      candidatenumber: this.candidateDetails.candidatenumber,
      isvalid: Number(isValid),
      candidatecontactdetailid: contactDetailObject.candidatecontactdetailid
    }
    this.personSearchService.markContactValidity(payload).subscribe((res: any) => {
      if(res && res.status === 'success') {
        this.successMessage = "Marked validity for contact successfully";
        setTimeout(() => this.successMessage = '', 3000);
      }
    }, (err: any) => {
      console.log("markContactValidity() err", err);
      this.errorMessage = "Something went wrong";
      setTimeout(() => this.errorMessage = '', 3000);
    }).add(() => this.getAllcontactDetails());
  }

  route2pricing() {
    this.modalService.dismissAll()
    this.router.navigateByUrl('/subscription/pricing')
  }

  fetchcredits() {
    this.transactionservice.fetchcurrentplandetails(this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == 'success') {
        let userData = this._localstorageservice.getItem('userdata')
        userData['balancebasiccontactenrichmentcredits'] = res.data.balancebasiccontactenrichmentcredits
        this._localstorageservice.setItem('userdata', userData)
        this.transactionservice.createPaymentData();
        if (res.data.teamadmindetails) {  
          // Here the logged in person is a Team Member
          this.isteamMember = true
        }
      }
    })
  }

  sendmailexpiry(type) {
    let data = {
      expiredmetric: type
    }
    this.transactionservice.sendcreditexpirymail(data).subscribe()
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  OpenSendEmailModule(preSelectEmail: string = null) {
    if (this._localstorageservice.getItem('secredits') > 0) {
      const modalRef = this.modalService.open(CandidateEmailComponent, { size: 'lg' as 'lg', centered: true });
      modalRef.componentInstance.emailforCandidate = this.candidateDetails ? { ...this.candidateDetails, basicdetails: { firstname: this.candidateDetails.first_name, lastname: this.candidateDetails.last_name }, contactdetails: { emails: { existingDetails: this.candidateDetails.existingContactDetails.filter(c => c.type === 'email') } } } : null
      modalRef.componentInstance.preSelectEmail = preSelectEmail
      modalRef.componentInstance.candidatenumber = this.candidateDetails.candidatenumber,
      modalRef.componentInstance.passEntry.subscribe((x) => {
        if (x == 'emailsend') {
          this.toastmessage('Email Send Successfully', 'success')
        } else if (x == 'nocredits') {
          this.modalService.open(this.noCreditsCE, { windowClass: "myCustomModalClass", centered: true });
          this.sendmailexpiry('Smart Email credits')
        } else if (x == 'limitexceeded') {
          this.toastmessage('mail limit exceeded', 'error')
        } else if (x == 'error') {
          this.toastmessage('Something went Wrong', 'error')
        }
      });
    } else {
      this.modalService.open(this.noCreditsCE, { windowClass: "myCustomModalClass", centered: true });
      this.sendmailexpiry('Smart Email credits')
    }
  }

  getProvidername(key){
    if(key != null){
      if(key.toString().toLowerCase() === 'pipl'){
        return 'Pipl'
      }else if(key.toString().toLowerCase() === 'pdl'){
        return 'People Data Labs'
      }else if(key.toString().toLowerCase() === 'rocketreach'){
        return 'RocketReach'
      }else if(key.toString().toLowerCase() === 'nymblr'){
        return 'Nymblr'
      }
    }
  }

  sendMessagetoChrome() {
    let chromeid = localStorage.getItem('extensionID');
    let isExtensioninstalled
    if (chromeid) {
      try {
        window['chrome'].runtime.sendMessage(chromeid, { action: 'refreshExtension', candidateNumber: this.candidateNumber }, function (res) {
          if (res && res.similarCandidateData) {
            isExtensioninstalled = true
          }
        });
      } catch (error) {
        if (error) {
          isExtensioninstalled = false
        }
        console.error('Here is the error message', error);
      }
      setTimeout(() => {
        this.isExtensioninstalled = isExtensioninstalled
      }, 500)
    }
  }

  clearDownDivdata(event){
    if(event.isTrusted){
      this.colvillform.patchValue(null);
      this.webbtreeIntroForm.patchValue(null);
      this.isWebbtreeIntroductionChecked = false
      this.showAllDivData=false;
      this.showAllDivDataWebbtreeIntro = false;
      this.showSuccessfulData=false;
    }
  }

  clearDownDivDataWebbtreeIntro(event){
    if(event.isTrusted){
      this.webbtreeIntroForm.patchValue(null)
      this.showAllDivDataWebbtreeIntro=false;
      this.showSuccessfulDataWebbtreeIntro=false;
    }
  }

  showHideFullDiv(event){
    if(event.isTrusted){
      this.radioForm = this.fb.group({
        option: [""]
      });
      this.showAllDivData=true;
      this.showSuccessfulData=false;
      this.isWebbtreeIntroductionChecked = false;
      this.webbtreeIntroForm.patchValue(null);
    }
  }


  showHideFullDivWebbtreeIntro(event){
    if(event.isTrusted){
      this.radioForm = this.fb.group({
        option: [""]
      });
      // this.webbtreeIntroRadioForm = this.fb.group({
      //   option: [""]
      // });
      this.isWebbtreeIntroductionChecked = true;
      this.showAllDivDataWebbtreeIntro=true;
      this.showSuccessfulDataWebbtreeIntro=false;
      this.colvillform.patchValue(null);
    }
  }

  checkedInput(checkboxvalue: string): void {
    this.showRequestSpinner = false;
    const index = this.selectedInputValues.indexOf(checkboxvalue);

    if (index !== -1) {
      this.selectedInputValues.splice(index, 1);
    } else {
      this.selectedInputValues.push(checkboxvalue);
    }
  
    this.personalContactChecked = this.selectedInputValues.includes('contactnumber');
    this.personalEmailChecked = this.selectedInputValues.includes('personalemail');
  
  }

  makeContractRequest(event){

    // if(this.personalContactChecked || this.personalEmailChecked){
      this.showRequestSpinner = true;
      const userData = this._localstorageservice.getItem('userdata')

      const obj = { elasticid: this.candidateDetails.id , contactrequested : this.selectedInputValues }
  
      this.requestContract.getRequestContract(obj).subscribe((res:any)=>{
          if(res.status == "success"){
            this.showRequestSpinner = false;
            this.showAllDivData=false;
            this.showSuccessfulData=true;
            this.fetchcredits()
            this.candidateDetails["iswebbtreeverified"] = 1
            let eventdata = {
              action: 'append-data',
              data: this.candidateDetails
            }
            this.handleOutputEvent.emit(eventdata)
          }else{
            this.showAllDivData=true;
            this.showSuccessfulData=false;
            this.showRequestSpinner = false;
            this.toastmessage('You don`t have enough credits!', 'error')
          }
      })
    // }
  }


  makeWebbtreeIntroductionRequest(){
    if( this.webbtreeIntroductionForm['controls'].requirement.value &&  this.webbtreeIntroductionForm['controls'].requirement.value.length){
      if( this.webbtreeIntroductionForm['controls'].requirement.value.length > 10 &&  this.webbtreeIntroductionForm['controls'].requirement.value.length <= 1000){
        this.showwebtreeintrospinner = true;
        let clientRequirement : any = this.webbtreeIntroductionForm['controls'].requirement.value
        clientRequirement = clientRequirement.replaceAll("\n", "<br/>")
        const obj = { elasticid: this.candidateDetails.id, requirement: clientRequirement  }
    
        this.personSearchService.makeRequestContact(obj).subscribe((res:any)=>{
            if(res.status == "success"){
              this.modalService.dismissAll();
              this.showwebtreeintrospinner = false;
              this.showAllDivDataWebbtreeIntro=false;
              this.showSuccessfulDataWebbtreeIntro=true;
              this.fetchcredits()
              this.candidateDetails["usedWebbtreeIntroduction"] = 1
              let eventdata = {
                action: 'append-data',
                data: this.candidateDetails
              }
              this.handleOutputEvent.emit(eventdata)
              this.toastmessage('We have successfully submitted your request ', 'success')
    
            }else{
              this.showAllDivDataWebbtreeIntro=true;
              this.showSuccessfulDataWebbtreeIntro=false;
              this.showwebtreeintrospinner = false;
              this.toastmessage('You don`t have enough credits!', 'error')
            }
        })
      }else{
        return false
      }
    }else{
      this.webbtreeIntroductionForm.get('requirement').setErrors({ 'no-input': true })
      return false
    }
  }

  isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
  }



  checkProperties(obj): boolean {
    if(obj){
      return obj.work_email && obj.personal_email && obj.phone;
    }
  }

  checkIfProviderisEmptyAndNoPreviewResponse(data): boolean {
    let nymblrExists = false;
    // let piplExists = false;

    let canShow = false;
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
          if (key === 'nymblr') {
              nymblrExists = true;
          }
          // if (key === 'pipl') {
          //     piplExists = true;
          // }
          if (this.checkProperties(data[key])) {
             canShow = true;
          }else{
            canShow = false;
          }
      }
    }
    if(nymblrExists || canShow){
      return true;
    }else{
      return false;
    }

  }

  /**On click add to contact button seperate component for add to contact call */
  callAddToContactComponent(){
    this.canShowAddToContact = true;
    document.getElementById("maual-contact-form").scrollIntoView({ 
      behavior: 'smooth' 
    });
  }

  /**On click of cancel button in add to component event emit and close add to contact component */
  closeAddToContact(event) {
    if (event.status === 'contact-added-manually') {
      this.radioForm.reset();
      this.getAllcontactDetails('added-manually');
      this.sendMessagetoChrome();
      if(this.enrichedfrom === 'all-candidates' || this.enrichedfrom === 'talentpool'){
        // To refresh the candidate list
        this.handleOutputEvent.emit(null);
      }
    }
    else if (event.status === 'close') {

    }
    this.editManualContactInfo = {};
    this.canShowAddToContact = false;

  }

  /**
   * Allow editing based on type of email
   * @param contactType 
   * @param contactInfo 
   */
  editManualContact(contactType: string, contactInfo: any){
    this.editManualContactInfo = {
      type: contactType,
      contactValue: contactInfo.contactdetail,
      isPrimary: contactInfo.isprimary ? true : false,
      candidatecontactdetailid: contactInfo.candidatecontactdetailid
    }
    this.canShowAddToContact = true;
  }

  openWebbtreeIntroductionModal(){
    if(this.isWebbtreeIntroductionChecked === false){
      return;
    }
    this.modalService.open(this.webbtreeIntroductionModalBox,  { size: 'lg' as 'lg', backdrop: 'static', keyboard: false ,centered: true,});
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === ' ') {
      const inputValue = this.webbtreeIntroductionForm.controls.requirement.value;
      const trimmedValue = inputValue.trim()
      this.webbtreeIntroductionForm.controls.requirement.setValue(trimmedValue);
    }
  }
}
